import React from "react";
// import { BrowserRouter} from "react-router-dom";
// import { AuthProvider } from "./context/AuthContext";
import "./Dash.css";
// import DashboardLayout from "./DashboardLayout";
import Sidebar from "./components/sidebar";
import Menubar from "./pages/Menubar";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Users from "./pages/Users/Users";
import Customers from "./pages/Users/Customers";
import Comment from "./components/Comment/Comment";
import Analytics from "./components/Analytics/Analytics";
import Product from "./components/Product/Product";
import ProductList from "./components/ProductList/ProductList";
import Orders from "./components/Orders/Orders";
import Transaction from "./components/Transaction/Transaction";
import CreateProducts from "./pages/Products/CreateProducts";
import DetailProducts from "./pages/Products/DetailProducts";
import AddRecipes from "./pages/Recipes/AddRecipes";
import DisplayRecipes from "./pages/Recipes/DisplayRecipes";
import RemedyForm from "./pages/remedies/RemedyForm";
import BlogForm from "./pages/Blog/BlogForm";
import AddCategory from "./pages/Category/AddCategory";
import DisplayCategory from "./pages/Category/DisplayCategory";
import AddCuisine from "./pages/Cuisine/AddCusine";
import AddBook from "./pages/Books/AddBook";
import DisplayBooks from "./pages/Books/DisplayBooks";
import DisplayCuisine from "./pages/Cuisine/DisplayCuisine";
import AddNewRecipes from "./pages/Recipes/AddNewRecipes";
import DisplayNewRecipes from "./pages/Recipes/DisplayNewRecipes";
import NotFound from "./pages/NotFound/NotFound";
import AddSubNewRecipes from "./pages/SubRecipes/AddSubNewRecipes";
import DisplaySubRecipes from "./pages/SubRecipes/DisplaySubRecipes";
import UpdaterecipesSubrecipes from "./pages/UpdaterecipesSubrecipes/UpdaterecipesSubrecipes";
import DeleterecipesSubrecipes from "./pages/UpdaterecipesSubrecipes/DeleterecipesSubrecipes";

import Login from "./pages/Login/Login";
// import Dashboard from "./pages/Dashboard";
import WebsiteHome from "./pages/WebsiteHome/WebsiteHome";
import Signup from "./pages/Login/Signup";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import AddBeauty from "./pages/Beauty/AddBeauty";
import DisplayBeauty from "./pages/Beauty/DisplayBeauty";
import Addhair from "./pages/Beauty/Hair/Addhair";
// import Addhair from "./pages/Beauty/Hair/Addhair";
import Displayhair from "./pages/Beauty/Hair/Displayhair";
import Addskin from "./pages/Beauty/Skin/Addskin";
import Displayskin from "./pages/Beauty/Skin/Displayskin";
import Addmakeup from "./pages/Beauty/Makeup/Addmakeup";
import Displaymakeup from "./pages/Beauty/Makeup/Displaymakeup";
import Addwellness from "./pages/Beauty/Wellness/Addwellness";
import Displaywellness from "./pages/Beauty/Wellness/Displaywellness";
import Addbeautytips from "./pages/Beauty/Beautytips/Addbeautytips";
import Displaybeautytips from "./pages/Beauty/Beautytips/DisplayBeautytips";
import WebToolUsers from "./pages/Users/WebToolUsers";
import ChildWebUsers from "./pages/Users/ChildWebUsers";
import DisplayDictionary from "./pages/Dictionary/DisplayDictionary";
import AddDictionary from "./pages/Dictionary/AddDictionary";
import DisplayExplanations from "./pages/Commentary/DisplayExplanations";
import AddExplanation from "./pages/Commentary/AddExplanation";
import DisplayExplanationsEn from "./pages/CommentaryEn/DisplayExplanationsEn";
import AddExplanationEn from "./pages/CommentaryEn/AddExplanationEn";

import AddBibleSurvey from "./pages/BibleSurvey/AddBibleSurvey";
import DisplayBibleSurveys from "./pages/BibleSurvey/DisplayBibleSurveys";
import GenerateBibleSurvey from "./pages/BibleSurvey/GenerateBibleSurvey";

import DisplayGeneralChurchHistory from "./pages/GeneralChurch/DisplayGeneralChurchHistory";
import DisplayComparison from "./pages/GeneralChurch/DisplayComparison";
import DisplayDoctrines from "./pages/GeneralChurch/DisplayDoctrines";
import DisplayReligions from "./pages/GeneralChurch/DisplayReligions";
import DisplayTimeline from "./pages/GeneralChurch/DisplayTimeline";
import DisplayApologetics from "./pages/GeneralChurch/DisplayApologetics";
import MessageDashboard from "./pages/MessageApp/MessageDashboard";
import DisplayYoutubeVideos from "./pages/YoutubeManual/DisplayYoutubeVideos";
import AddYoutubeVideo from "./pages/YoutubeManual/AddYoutubeVideo";

import DisplayBiblicalPlaces from "./pages/Places/DisplayBiblicalPlaces";
import DisplayOfflineReader from "./pages/Reader/DisplayOfflineReader";
import DisplayAIFlags from "./pages/Flags/DisplayAIFlags";
// import Header from "./src/components/Header";

// import Displaybeautytips from "./pages/Beauty/Beautytips/Displaybeautytips";

const Dash = () => {
  const isAuthenticated = () => !!localStorage.getItem("token");
  // <Header logout={logout} />
  return (
    <div>
      <Sidebar>
        <Menubar />
        <Routes>
          {/* <Route path="/" element={<Dashboard />} /> */}

          <Route path="/website" element={<WebsiteHome />} />
          <Route path="/users" element={<Users />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/comment" element={<Comment />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/addrecipes" element={<AddRecipes />} />
          <Route path="/listsallrecipes" element={<DisplayRecipes />} />
          <Route path="/addnewrecipes" element={<AddNewRecipes />} />
          <Route path="/listsnewallrecipes" element={<DisplayNewRecipes />} />
          <Route path="/addsubrecipes" element={<AddSubNewRecipes />} />
          <Route path="/listssuballrecipes" element={<DisplaySubRecipes />} />
          <Route
            path="/updaterecipesubrecipe"
            element={<UpdaterecipesSubrecipes />}
          />
          <Route
            path="/deleterecipesubrecipe"
            element={<DeleterecipesSubrecipes />}
          />

          <Route
            path="/updaterecipesubrecipe/:title_id"
            element={<UpdaterecipesSubrecipes />}
          />
          <Route path="/orders" element={<Orders />} />
          <Route path="/transaction" element={<Transaction />} />

          <Route path="/addremedy" element={<RemedyForm />} />

          <Route path="/addblog" element={<BlogForm />} />

          <Route path="/createproducts" element={<CreateProducts />} />
          <Route path="/detailproducts" element={<DetailProducts />} />
          {/* <Route path="/editproducts/:idp" element={<EditProducts />} /> */}
          {/* <Route path="/listingproducts" element={<ListingProducts />} /> */}
          <Route path="/addcategory" element={<AddCategory />} />
          <Route path="/displaycategory" element={<DisplayCategory />} />

          <Route path="/addcuisine" element={<AddCuisine />} />
          <Route path="/displaycuisine" element={<DisplayCuisine />} />
          <Route path="/addbook" element={<AddBook />} />
          <Route path="/displaybooks" element={<DisplayBooks />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/websitehome" element={<WebsiteHome />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/addbeauty" element={<AddBeauty />} />
          <Route path="/displaybeauty" element={<DisplayBeauty />} />
          <Route path="/addhaircare" element={<Addhair />} />
          <Route path="/displayhaircare" element={<Displayhair />} />
          <Route path="/addskincare" element={<Addskin />} />
          <Route path="/displayskincare" element={<Displayskin />} />
          <Route path="/addmakeup" element={<Addmakeup />} />
          <Route path="/displaymakeup" element={<Displaymakeup />} />
          <Route path="/addwellness" element={<Addwellness />} />
          <Route path="/displaywellness" element={<Displaywellness />} />
          <Route path="/addbeautytips" element={<Addbeautytips />} />
          <Route path="/displaybeautytips" element={<Displaybeautytips />} />

          {/* webtools */}
          <Route path="/webusers" element={<WebToolUsers />} />
          <Route path="/childwebusers" element={<ChildWebUsers />} />

          <Route path="/displaydictionary" element={<DisplayDictionary />} />
          <Route path="/adddictionary" element={<AddDictionary />} />
          <Route
            path="/displayexplanations"
            element={<DisplayExplanations />}
          />
          <Route path="/addexplanation" element={<AddExplanation />} />
          <Route
            path="/displayexplanationsEn"
            element={<DisplayExplanationsEn />}
          />
          <Route path="/addexplanationEn" element={<AddExplanationEn />} />

          <Route path="/addbiblesurvey" element={<AddBibleSurvey />} />
          <Route
            path="/displaybiblesurveys"
            element={<DisplayBibleSurveys />}
          />
          <Route
            path="/generatebiblesurvey"
            element={<GenerateBibleSurvey />}
          />

          <Route
            path="/generalchurchhistory"
            element={<DisplayGeneralChurchHistory />}
          />
          <Route path="/comparison" element={<DisplayComparison />} />
          <Route path="/doctrines" element={<DisplayDoctrines />} />
          <Route path="/religions" element={<DisplayReligions />} />
          <Route path="/timeline" element={<DisplayTimeline />} />
          <Route path="/apologetics" element={<DisplayApologetics />} />
          <Route path="/messageapp" element={<MessageDashboard />} />
          <Route path="/display-youtube" element={<DisplayYoutubeVideos />} />
          <Route path="/add-youtube" element={<AddYoutubeVideo />} />

          <Route path="/display-places" element={<DisplayBiblicalPlaces />} />
          <Route path="/display-reader" element={<DisplayOfflineReader />} />
          <Route path="/display-flags" element={<DisplayAIFlags />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Sidebar>
    </div>
  );
};

export default Dash;

// const Dash = () => {
//   return (
//     //  <AuthProvider>
//       {/* <BrowserRouter> */}
//     <Routes>
//       {/* Public routes */}
//       <Route path="/" element={<Login />} />
//       {/* <Route path="/login" element={<Login />} /> */}
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/forgot-password" element={<ForgotPassword />} />
//       <Route path="/websitehome" element={<WebsiteHome />} />
//       {/* Catch-All Route */}
//           <Route path="*" element={<WebsiteHome />} />

//       {/* Protected Routes for admin/editor */}
//       <Route
//         path="/dashboard/*"
//         element={
//           <ProtectedLayout allowedRoles={["admin", "editor"]}>
//             <DashboardLayout>
//               <Routes>
//                 <Route path="" element={<Dashboard />} />
//                 <Route path="users" element={<Users />} />
//                 <Route path="comment" element={<Comment />} />
//                 <Route path="analytics" element={<Analytics />} />
//                 <Route path="createproducts" element={<CreateProducts />} />
//                 <Route path="detailproducts" element={<DetailProducts />} />
//                 <Route path="orders" element={<Orders />} />
//                 <Route path="transaction" element={<Transaction />} />
//                 {/* Add more dashboard routes here */}
//               </Routes>
//             </DashboardLayout>
//           </ProtectedLayout>
//         }
//       />
//     </Routes>
//     //  </BrowserRouter>
//     // </AuthProvider>
//   );
// };

// export default Dash;

// Dash.js
// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Login from "./pages/Login/Login";
// import Signup from "./pages/Login/Signup";
// import ForgotPassword from "./pages/Login/ForgotPassword";
// import WebsiteHome from "./pages/WebsiteHome/WebsiteHome";

// import ProtectedLayout from "./components/ProtectedLayout";
// import DashboardLayout from "./layout/DashboardLayout";

// import Dashboard from "./pages/Dashboard/Dashboard";
// import Users from "./pages/Users/Users";
// import Comment from "./components/Comment/Comment";
// import Analytics from "./components/Analytics/Analytics";
// import CreateProducts from "./pages/Products/CreateProducts";
// import DetailProducts from "./pages/Products/DetailProducts";
// import Orders from "./components/Orders/Orders";
// import Transaction from "./components/Transaction/Transaction";

// const Dash = () => {
//   return (
//     <Routes>
//       {/* Public routes */}
//       <Route path="/" element={<Login />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/forgot-password" element={<ForgotPassword />} />
//       <Route path="/websitehome" element={<WebsiteHome />} />

//       {/* Protected Routes */}
//       <Route
//         path="/dashboard"
//         element={
//           <ProtectedLayout allowedRoles={["admin", "editor"]}>
//             <DashboardLayout />
//           </ProtectedLayout>
//         }
//       >
//         {/* Nested inside /dashboard */}
//         <Route index element={<Dashboard />} />
//         <Route path="users" element={<Users />} />
//         <Route path="comment" element={<Comment />} />
//         <Route path="analytics" element={<Analytics />} />
//         <Route path="createproducts" element={<CreateProducts />} />
//         <Route path="detailproducts" element={<DetailProducts />} />
//         <Route path="orders" element={<Orders />} />
//         <Route path="transaction" element={<Transaction />} />
//       </Route>
//     </Routes>
//   );
// };

// export default Dash;
